(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hb-catalog-mode"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit',function(event){
  const form=event.target;
  if(!(form instanceof HTMLFormElement))return;
  const action=new URL(form.action,window.location.href).pathname;
  if(action==='/checkout'||action.endsWith('/cart/checkout')||event.submitter?.name==='checkout'){
    event.preventDefault();
    event.stopImmediatePropagation();
    if(!form.querySelector('.hb-catalog-form-notice')){
      const notice=document.createElement('p');
      notice.className='hb-catalog-form-notice';
      notice.setAttribute('role','status');
      notice.textContent=document.querySelector('[data-hb-catalog-notice]')?.textContent||'';
      form.appendChild(notice);
    }
  }
},true);
document.addEventListener('click',function(event){
  const target=event.target instanceof Element?event.target.closest('a,button,input'):null;
  if(!target)return;
  const href=target instanceof HTMLAnchorElement?new URL(target.href,window.location.href).pathname:'';
  if(target.getAttribute('name')==='checkout'||href==='/checkout'||href.endsWith('/cart/checkout')){
    event.preventDefault();
    event.stopImmediatePropagation();
  }
},true);
  } catch(e) { console.error(e); }
})();

})();
